import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ReactGA from 'react-ga4';

// Skip analytics while react-snap pre-renders pages at build time
if (navigator.userAgent !== 'ReactSnap') {
  ReactGA.initialize('G-24SF43NT7K');
}

const rootElement = document.getElementById('root');

// ✅ This fires as soon as React finishes its first render
// It hides the HTML loading screen — NO double loader
function onReactReady() {
  if (window.__HIDE_APP_LOADER__) {
    window.__HIDE_APP_LOADER__();
    return;
  }

  // Fallback: if loader.js was blocked or failed to load, tear the overlay
  // down here. Without this the fixed, z-index 9999 splash covers the whole
  // page forever and the site looks down even though it rendered fine.
  const loader = document.getElementById('app-loading-screen');
  if (loader) {
    loader.classList.add('hidden');
    setTimeout(() => loader.remove(), 400);
  }
}

if (rootElement.hasChildNodes()) {
  // react-snap pre-rendered page — use hydrateRoot
  const root = ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  // Hide loader after hydration
  onReactReady();
} else {
  // Normal client-side render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  // Hide loader after first render
  onReactReady();
}
